import axios from "axios";

const baseUrl = "/AutoConnectSSO/api/Authentication/Shared/UserSession";

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

function getUrl(urlPath: string) {
  return `/${urlPath}`;
}

async function getUserAuthenticationLevel() {
  const url = getUrl("UserAuthenticationLevel");
  const response = await instance.get(url);
  return response.data;
}

export const UserSessionService = {
  getUserAuthenticationLevel
};
